export default {"src":"/_next/static/media/RFX_DISABLED_ICON.273e0cb9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};